/**
 * W66.W6 — Posture pill for Top-10 Account Sales Plan.
 * Postures: WORST CASE / STRETCH / COMMIT / DISQUALIFY
 * Color mapping per canon:
 *   COMMIT      → #16A34A (canon green)
 *   STRETCH     → #16A34A (canon green)
 *   WORST CASE  → #DC2626 (canon red)
 *   DISQUALIFY  → #6B7280 (canon gray)
 */

import React from "react";

interface PosturePillProps {
  posture: string | null;
  small?: boolean;
}

const POSTURE_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  COMMIT: {
    bg: "#16A34A",
    text: "#FFFFFF",
    label: "COMMIT",
  },
  STRETCH: {
    bg: "#16A34A",
    text: "#FFFFFF",
    label: "STRETCH",
  },
  "WORST CASE": {
    bg: "#DC2626",
    text: "#FFFFFF",
    label: "WORST CASE",
  },
  DISQUALIFY: {
    bg: "#6B7280",
    text: "#FFFFFF",
    label: "DISQUALIFY",
  },
};

export default function PosturePill({ posture, small = false }: PosturePillProps) {
  if (!posture) {
    return (
      <span
        style={{
          background: "#F3F4F6",
          color: "#9CA3AF",
          borderRadius: 4,
          padding: small ? "2px 6px" : "3px 10px",
          fontSize: small ? 10 : 11,
          fontWeight: 600,
          letterSpacing: "0.05em",
          textTransform: "uppercase" as const,
          whiteSpace: "nowrap" as const,
        }}
      >
        —
      </span>
    );
  }

  const style = POSTURE_STYLES[posture.toUpperCase()] ?? {
    bg: "#6B7280",
    text: "#FFFFFF",
    label: posture.toUpperCase(),
  };

  return (
    <span
      style={{
        background: style.bg,
        color: style.text,
        borderRadius: 4,
        padding: small ? "2px 6px" : "3px 10px",
        fontSize: small ? 10 : 11,
        fontWeight: 700,
        letterSpacing: "0.05em",
        textTransform: "uppercase" as const,
        whiteSpace: "nowrap" as const,
      }}
    >
      {style.label}
    </span>
  );
}
